import { ChangeDetectionStrategy, Component } from '@angular/core'
import { OrderConfirmationItemsComponent, OrderDetailsService } from '@spartacus/order/components'
import { OrderFacade } from '@spartacus/order/root'

@Component({
    selector: 'eb-order-confirmation-items',
    templateUrl: './eb-order-confirmation-items.component.html',
    styleUrls: ['./eb-order-confirmation-items.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EbOrderConfirmationItemsComponent extends OrderConfirmationItemsComponent {
  order$ = this.orderDetailsService.getOrderDetails()
  constructor(
    orderService: OrderFacade,
    protected orderDetailsService: OrderDetailsService
  ) {
    super(orderService)
  }
  ngOnDestroy() {
    super.ngOnDestroy()
  }
}
